import {httpsCallable} from 'firebase/functions';
import {firebaseFunction} from '../../config/firebase';

export function createCallable<TRequest = unknown, TResponse = unknown>(name: string) {
  const fn = httpsCallable<TRequest, TResponse>(firebaseFunction, name);
  return (data: TRequest) => fn(data).then((r) => r.data);
}
